[
    {
        "name": "ekornet",
        "shortcodes": [
            ":ekornet:"
        ],
        "url": "emotes/Maskorama/ekornet.webp",
        "category": "Maskorama",
        "height": 55,
        "width": 75
    },
    {
        "name": "flippklipp",
        "shortcodes": [
            ":flippklipp:"
        ],
        "url": "emotes/Logoer/flippklipp.webp",
        "category": "Logoer",
        "height": 58,
        "width": 75
    },
    {
        "name": "frøken-smult",
        "shortcodes": [
            ":frøken-smult:"
        ],
        "url": "emotes/Reaksjoner/frøken-smult.webp",
        "category": "Reaksjoner",
        "height": 73,
        "width": 75
    },
    {
        "name": "herr-bæsj",
        "shortcodes": [
            ":herr-bæsj:"
        ],
        "url": "emotes/Maskorama/herr-bæsj.webp",
        "category": "Maskorama",
        "height": 75,
        "width": 59
    },
    {
        "name": "humla",
        "shortcodes": [
            ":humla:"
        ],
        "url": "emotes/Maskorama/humla.webp",
        "category": "Maskorama",
        "height": 75,
        "width": 72
    },
    {
        "name": "kp-bart-1",
        "shortcodes": [
            ":kp-bart-1:"
        ],
        "url": "emotes/Reaksjoner/kp-bart-1.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 72
    },
    {
        "name": "kp-bart-2",
        "shortcodes": [
            ":kp-bart-2:"
        ],
        "url": "emotes/Reaksjoner/kp-bart-2.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 71
    },
    {
        "name": "kp-dilla",
        "shortcodes": [
            ":kp-dilla:"
        ],
        "url": "emotes/Reaksjoner/kp-dilla.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 64
    },
    {
        "name": "kp-on",
        "shortcodes": [
            ":kp-on:"
        ],
        "url": "emotes/Reaksjoner/kp-on.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 75
    },
    {
        "name": "kp-tenk",
        "shortcodes": [
            ":kp-tenk:"
        ],
        "url": "emotes/Reaksjoner/kp-tenk.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 75
    },
    {
        "name": "muldvarpen",
        "shortcodes": [
            ":muldvarpen:"
        ],
        "url": "emotes/Maskorama/muldvarpen.webp",
        "category": "Maskorama",
        "height": 75,
        "width": 57
    },
    {
        "name": "pingvinen",
        "shortcodes": [
            ":pingvinen:"
        ],
        "url": "emotes/Maskorama/pingvinen.webp",
        "category": "Maskorama",
        "height": 75,
        "width": 59
    },
    {
        "name": "pinnsvinet",
        "shortcodes": [
            ":pinnsvinet:"
        ],
        "url": "emotes/Maskorama/pinnsvinet.webp",
        "category": "Maskorama",
        "height": 63,
        "width": 75
    },
    {
        "name": "piraten",
        "shortcodes": [
            ":piraten:"
        ],
        "url": "emotes/Maskorama/piraten.webp",
        "category": "Maskorama",
        "height": 75,
        "width": 75
    },
    {
        "name": "riksløven",
        "shortcodes": [
            ":riksløven:"
        ],
        "url": "emotes/Maskorama/riksløven.webp",
        "category": "Maskorama",
        "height": 63,
        "width": 75
    },
    {
        "name": "tonje-hater",
        "shortcodes": [
            ":tonje-hater:"
        ],
        "url": "emotes/Reaksjoner/tonje-hater.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 75
    },
    {
        "name": "tonje-love",
        "shortcodes": [
            ":tonje-love:"
        ],
        "url": "emotes/Reaksjoner/tonje-love.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 75
    },
    {
        "name": "tonje-wii",
        "shortcodes": [
            ":tonje-wii:"
        ],
        "url": "emotes/Reaksjoner/tonje-wii.webp",
        "category": "Reaksjoner",
        "height": 75,
        "width": 75
    },
    {
        "name": "tonjeee",
        "shortcodes": [
            ":tonjeee:"
        ],
        "url": "emotes/Reaksjoner/tonjeee.webp",
        "category": "Reaksjoner",
        "height": 68,
        "width": 75
    },
    {
        "name": "vulkanen",
        "shortcodes": [
            ":vulkanen:"
        ],
        "url": "emotes/Maskorama/vulkanen.webp",
        "category": "Maskorama",
        "height": 75,
        "width": 58
    },
    {
        "name": "yt",
        "shortcodes": [
            ":yt:"
        ],
        "url": "emotes/Logoer/yt.webp",
        "category": "Logoer",
        "height": 75,
        "width": 75
    }
]
